<script>
    import Modal from "../components/Modal_series.svelte";	
    import Modal_alta from "../components/Modal_alta.svelte";	
    import Modal2 from "../components/Modal.svelte";	
    import { Datatable, rows } from 'svelte-simple-datatables'
    import { onMount } from 'svelte';
    import { idcliente_serie, nombre_cliente } from '../store/series.js';
    import Top from "../components/top.svelte";	
    let data=[]; 
    let show = true;
    let modal_alta_serie;
    let idcliente = $idcliente_serie;
    let empresa = $nombre_cliente;
    let series=[];
    let idserie;
    let serie;
    let referencia;
    let host = "127.0.0.1";
    let port="3319";
    let user = "root";
    let passw = "root";
    let sistem = "Windows";
    let modal_conceptos;
    let conceptosa=[];
    let modal_alta_servicio;
    let concepto_alta;
    let mensual_alta;
    let fijo_alta;
    let idservicio;
    let show_a=true;
    let show_a1;
    let show_a2;
    let show_a3;
    let actives = "pestaña3";
    let actives1 = "pestaña2"; 
    let actives2 = "pestaña2";
    let actives3 = "pestaña2";
    let modal_editar_serie;
    let serie_editar;
    let referencia_editar;
    let host_editar;
    let port_editar;
    let user_editar;
    let passw_editar;
    let sistem_editar;
    let info=[];
    let activer = "pestaña1";
    let activer1 = "pestaña";
    let activer2 = "pestaña";
    let SQL_Host;
    let SQL_Database;
    let SQL_Usuario;
    let SQL_Password;
    let SQL_Puerto;
    let FTP_Host;
    let FTP_Directorio;
    let FTP_Usuario;
    let FTP_Password;
    let FTP_Puerto;
    let correo_sesion;
    let password;
    let show1 =false;
    let modal_contactos;
    let contactos=[];
    let modal_alta_contacto;
    let nombre_contacto;
    let telefono_fijo;
    let celular_contacto;
    let puesto_contacto;
    let correo_contacto;
    let modal_modificar_contacto;
    let nombre_contacto_editar; 
    let telefono_fijo_editar;
    let celular_contacto_editar;
    let puesto_contacto_editar;
    let correo_contacto_editar;
    let idcontacto;
    let pago_modal1;
    let tarjeta_number;
    let MM;
    let AA;
    let cvc;
    let cantidad;
    let idstripe;
    let idtarjeta;
    let descripcion;
    let res3=[];
    let idservicio_pago;
    let idtarjeta_predeterminada;
    let predeterminada;
    let pago_modal_anualidad;
    let pago_modal3;
    let pago_modal;
	let ver = true;
	let ver1 = false;
    let activar="pestaña1";
    let activar1="pestaña";
    let tarjetas = [];
    let modal_agregar_tarjeta;
    let licencias_mas;
    let licencias_extra;
    let cargos_extra=[];
    let licencias_activas;
    let precio_suscripcion;
    let fecha_proximo;
    let idsuscripcion;
    let idmensualidad;
    let precio_mensualidad;
    let fecha_proxima_mensualidad;
    let tipo;
    async function eliminar_licencia(){
        if(licencias_activas >= info.Licencias_Pagadas){
            modal_tecnicos.show();
        } else {
            let r2 = window.confirm("Eliminara una licencia extra, confirme la accion. Atencion: no hay reembolso al eliminar la licencia");
            if (r2 == true) {
                try {
                licencias_mas =  parseInt(info.Licencias_Pagadas) - 1;
                const data = new FormData();
                data.append('id', info.idcliente);
                data.append('licencias', licencias_mas);
                let res = await fetch('php/delete-licencia-cliente.php', {
                    method : "POST",
                    body: data
                })		
                alert("Eliminado con exito");
                actualizar();
                } catch(e) {
                    const { responses } = e;
                    const { request, ...errorObject } = responses; // take everything but 'request'
                    console.log(errorObject);
                    }
            }
        }
        
    }
    async function agregar_tarjeta(){la
        modal_agregar_tarjeta.show();
    }
    async function licencia_tecnico(){
        let r2 = window.confirm("Confirme la adquicision de una licencia de tecnico extra por un costo de $ 1000.00");
        if (r2 == true) {
            try {
            licencias_mas =  parseInt(info.Licencias_Pagadas) + 1;
            const data = new FormData()
            data.append('idtarjeta', idtarjeta_predeterminada);
            data.append('idstripe', info.idstripe);
            data.append('licencias', licencias_mas);
            let res = await fetch('php/licencia-extra-cliente.php', {
                method : "POST",
                body: data
            })		
            if(!idmensualidad){
                const data = new FormData()
                data.append('idstripe', info.idstripe);
                data.append('precio', 'price_1IvUlbBREWH2YEglyp7MVozf');
                let res = await fetch('php/suscripcion_clientes.php', {
                    method : "POST",
                    body: data
                })		
            } else {
                alert("Listo")
            }
            alert("Cobro realizado con exito");
            actualizar();
            } catch(e) {
                const { responses } = e;
                const { request, ...errorObject } = responses; // take everything but 'request'
                console.log(errorObject);
                }
        }
    }
    async function eliminar_tarjeta(i){
        if(tarjetas[i].id == idtarjeta_predeterminada){
            alert("No puede eliminar la tarjeta predeterminada");
        }else{
        let r2 = window.confirm("¿Desea eliminar la tarjeta **** **** **** " + tarjetas[i].last4 + "?");
            if (r2 == true) {
                const data1 = new FormData()
                data1.append('idtarjeta', tarjetas[i].id);
                data1.append('idstripe', info.idstripe);
                let resa = await fetch('php/baja-tarjeta.php', {
                    method : "POST",
                    body: data1
                })		
                const url3 = 'php/get-tarjetas.php?idstripe=' + info.idstripe;
                let res3 = await fetch(url3)
                res3 = await res3.json()
                console.log(res3)
                tarjetas = res3.data;
                predeterminada = idtarjeta_predeterminada;
            }
        }
    }
    async function actualizar(){
        const url6 = 'php/get-contactos.php?id=' + idcliente;
        let res6 = await fetch(url6)
        res6 = await res6.json()
        contactos = res6.data;
        console.log(contactos);
                
        const url12 = 'php/get-cliente.php?id=' + idcliente;
        let res12 = await fetch(url12)
        res12 = await res12.json()
        info = res12.data;
        console.log(info)
        
        idstripe=info.idstripe;
        
       
        try { 
            const url = 'php/get-series.php?id=' + idcliente;
            let res = await fetch(url)
            res = await res.json()
            data = res.data;
            console.log(data)
            licencias_activas = data.length;
        } catch(e){
            data=[];
        }

        const url1 = 'php/get-conceptos.php?id=' + idcliente;
        let resa = await fetch(url1)
        resa = await resa.json()
        conceptosa = resa.data;
        console.log(resa.data)
        try { 
            const url3 = 'php/get-tarjetas.php?idstripe=' + info.idstripe;
            res3 = await fetch(url3)
            res3 = await res3.json();
            tarjetas = res3.data;
            predeterminada = idtarjeta_predeterminada;
        } catch(e){
            res3=[];
        }

        try { 
            const url4 = 'php/tarjeta-predeterminada.php?idstripe=' + idstripe;
            let res4 = await fetch(url4)
                res4 = await res4.json()
                console.log(res4)
                idtarjeta_predeterminada = res4.data.idtarjeta;
                predeterminada = idtarjeta_predeterminada;
        } catch(e){
            res3=[];
        }
        if(info.Licencias_Pagadas > 20){
            licencias_extra = parseInt(info.Licencias_Pagadas) - 20;
            for (var s = 0; s < licencias_extra; s++) {
               cargos_extra = [...cargos_extra, {
			    Concepto: "Licencia Extra", Pago: "52.50"
		        }]
            }
        }
    }
    async function modificar_preferente(){
        let r2 = window.confirm("Confirme el cambio de tarjeta predeterminada");
            if (r2 == true) {
                const data1 = new FormData()
                data1.append('idtarjeta', predeterminada);
                data1.append('idstripe', info.idstripe);
                data1.append('idtarjeta_predeterminada', idtarjeta_predeterminada);
                let resa = await fetch('php/cambiar-predeterminado.php', {
                    method : "POST",
                    body: data1
                })		
                const url3 = 'php/get-tarjetas.php?idstripe=' + info.idstripe;
                let res3 = await fetch(url3)
                res3 = await res3.json()
                console.log(res3)
                tarjetas = res3.data;
                const url4 = 'php/tarjeta-predeterminada.php?idstripe=' + idstripe;
                let res4 = await fetch(url4)
                res4 = await res4.json()
                console.log(res4)
                idtarjeta_predeterminada = res4.data.idtarjeta;
                predeterminada = idtarjeta_predeterminada;
            }
    }

    onMount(async () => {
        
        const url6 = 'php/get-contactos.php?id=' + idcliente;
        let res6 = await fetch(url6)
        res6 = await res6.json()
        contactos = res6.data;
        console.log(contactos);
                
        const url12 = 'php/get-cliente.php?id=' + idcliente;
        let res12 = await fetch(url12);
        res12 = await res12.json()
        info = res12.data;
        console.log(info)
        if(info.Tipo == "0"){
            tipo="paga";
        } 
        if(info.Tipo == "1"){
            tipo="Ilimitada";
        } 
        if(info.Tipo == "2"){
            tipo="Cortesia";
        } 
        idstripe=info.idstripe;
        idsuscripcion = info.idsuscripcion;
        idmensualidad = info.idsuscripcion_mensual;
       
        try { 
            const url = 'php/get-series.php?id=' + idcliente;
            let res = await fetch(url)
            res = await res.json()
            data = res.data;
            console.log(data)
            licencias_activas = data.length;
        } catch(e){
            data=[];
        }

        const url1 = 'php/get-conceptos.php?id=' + idcliente;
        let resa = await fetch(url1)
        resa = await resa.json()
        conceptosa = resa.data;
        console.log(resa.data)
        try { 
            const url3 = 'php/get-tarjetas.php?idstripe=' + info.idstripe;
            res3 = await fetch(url3)
            res3 = await res3.json();
            tarjetas = res3.data;
            predeterminada = idtarjeta_predeterminada;
        } catch(e){
            res3=[];
        }

        try { 
            const url4 = 'php/tarjeta-predeterminada.php?idstripe=' + idstripe;
            let res4 = await fetch(url4)
                res4 = await res4.json()
                console.log(res4)
                idtarjeta_predeterminada = res4.data.idtarjeta;
                predeterminada = idtarjeta_predeterminada;
        } catch(e){
            res3=[];
        }
        if(info.Licencias_Pagadas > 20){
            licencias_extra = parseInt(info.Licencias_Pagadas) - 20;
            for (var s = 0; s < licencias_extra; s++) {
               cargos_extra = [...cargos_extra, {
			    Concepto: "Licencia Extra", Pago: "52.50"
		        }]
            }
        }
        const url5 = 'php/suscripcion_pago.php?idstripe=' + idstripe;
        let res5 = await fetch(url5)
        res5 = await res5.json()
        console.log(res5);
        precio_mensualidad = res5;
        const url7 = 'php/suscripcion_fecha.php?idstripe=' + idstripe;
        let res7 = await fetch(url7)
        res7 = await res7.json();
        console.log(res7);
        fecha_proxima_mensualidad = res7;

        const url8 = 'php/anualidad_pago.php?idsuscripcion=' + idsuscripcion;
        let res8 = await fetch(url8)
        res8 = await res8.json()
        console.log(res8);
        precio_suscripcion = res8;
        const url9 = 'php/anualidad_fecha.php?idsuscripcion=' + idsuscripcion;
        let res9 = await fetch(url9)
        res9 = await res9.json();
        console.log(res9);
        fecha_proximo = res9;

    })
    async function pago_mensualidad(){
        
    }
    async function desactivar(i){
        idservicio = conceptosa[i].idservicio;
        let r2 = window.confirm("¿Desea desactivar el servicio " + conceptosa[i].Concepto + "? Aviso: no hay reembolso al desactivar un servicio");
        if (r2 == true) {
            try {
            const data = new FormData()
            data.append('id', idservicio);
            data.append('idcliente', idcliente);
            let res = await fetch('php/delete-servicio-activado.php', {
                method : "POST",
                body: data
            })
            console.log(res)
            alert("Desaactivado con exito");
            const url1 = 'php/get-conceptos.php?id=' + idcliente;
            let resa = await fetch(url1)
            resa = await resa.json()
            conceptosa = resa.data;
            console.log(resa.data)
	} catch(e) {
		const { responses } = e;
		const { request, ...errorObject } = responses; // take everything but 'request'
		console.log(errorObject);
		}
        }
    }
    async function agregar_tarjeta_nueva(){
            const data1 = new FormData()
            data1.append('month', MM);
            data1.append('year', AA);
            data1.append('cvc', cvc);
            data1.append('idstripe', info.idstripe);
            let resa = await fetch('php/alta-tarjeta.php', {
                method : "POST",
                body: data1
            })		
			resa = await resa.json()
			console.log(resa);
            if(resa){
            const data2 = new FormData()
            data2.append('idstripe', info.idstripe);
            data2.append('idtarjeta', resa);
            let resa1 = await fetch('php/guardar-tarjeta-nueva.php', {
                method : "POST",
                body: data2
            })	
            }
            const url3 = 'php/get-tarjetas.php?idstripe=' + idstripe;
            let res3 = await fetch(url3)
            res3 = await res3.json()
            console.log(res3)
            tarjetas = res3.data;
            predeterminada = idtarjeta_predeterminada;
            modal_agregar_tarjeta.hide();
    }
    async function pagar_online1(i){
        if(info.idsuscripcion){
            if(info.idsuscripcion_mensual){
                console.log(res3.data)
                cantidad=conceptosa[i].Precio_mensual;
                cantidad = cantidad.replace(".","");
                if(res3.data != ""){
                    idservicio_pago=conceptosa[i].idservicio;
                    descripcion=conceptosa[i].Concepto;
                    const data3 = new FormData()
                    data3.append('idtarjeta', predeterminada);
                    data3.append('idstripe', idstripe);
                    data3.append('cantidad', cantidad);
                    data3.append('descripcion', descripcion);
                    data3.append('idservicio', idservicio_pago);
                    data3.append('idcliente', idcliente);
                    let res5 = await fetch('php/pago_servicio.php', {
                        method : "POST",
                        body: data3
                    })	
                    const url1 = 'php/get-conceptos.php?id=' + idcliente;
                    let resa = await fetch(url1)
                    resa = await resa.json()
                    conceptosa = resa.data;
                    console.log(resa.data)

                    const data4 = new FormData()
                    data4.append('idstripe', idstripe);
                    let res4 = await fetch('php/suscripcion-mensual-agregar.php', {
                        method : "POST",
                        body: data4
                    })		
                    alert("Cobro realizado");
                }else{
                    pago_modal3.show();
                    idservicio_pago=conceptosa[i].idservicio;
                    descripcion=conceptosa[i].Concepto;
                }
            }else{
                console.log(res3.data)
                cantidad=conceptosa[i].Precio_mensual;
                cantidad = cantidad.replace(".","");
                if(res3.data != ""){
                    idservicio_pago=conceptosa[i].idservicio;
                    descripcion=conceptosa[i].Concepto;
                    const data3 = new FormData()
                    data3.append('idtarjeta', predeterminada);
                    data3.append('idstripe', idstripe);
                    data3.append('cantidad', cantidad);
                    data3.append('descripcion', descripcion);
                    data3.append('idservicio', idservicio_pago);
                    data3.append('idcliente', idcliente);
                    let res5 = await fetch('php/pago_servicio.php', {
                        method : "POST",
                        body: data3
                    })	
                    const url1 = 'php/get-conceptos.php?id=' + idcliente;
                    let resa = await fetch(url1)
                    resa = await resa.json()
                    conceptosa = resa.data;
                    console.log(resa.data)
                    
                    const data4 = new FormData()
                    data4.append('idstripe', idstripe);
                    let res4 = await fetch('php/suscripcion-mensual.php', {
                        method : "POST",
                        body: data4
                    })		
                    alert("Cobro realizado");
                }else{
                    pago_modal3.show();
                    idservicio_pago=conceptosa[i].idservicio;
                    descripcion=conceptosa[i].Concepto;
                }
            }
        }else {
            alert("Necesita pagar primero los servicios de nube para poder contratar estos servicios");
        }
    }
    const settings = { columnFilter: false }
    let modal;
    async function pagar_online(i){
        if(info.idsuscripcion){
            console.log(res3.data)
            cantidad=conceptosa[i].Precio_mensual;
            cantidad = cantidad.replace(".","");
            if(res3.data != ""){
                idservicio_pago=conceptosa[i].idservicio;
                descripcion=conceptosa[i].Concepto;
                const data3 = new FormData()
                data3.append('idtarjeta', predeterminada);
                data3.append('idstripe', idstripe);
                data3.append('cantidad', cantidad);
                data3.append('descripcion', descripcion);
                data3.append('idservicio', idservicio_pago);
                data3.append('idcliente', idcliente);
                let res5 = await fetch('php/pago_servicio.php', {
                    method : "POST",
                    body: data3
                })	
                alert("Cobro realizado");
                const url1 = 'php/get-conceptos.php?id=' + idcliente;
                let resa = await fetch(url1)
                resa = await resa.json()
                conceptosa = resa.data;
                console.log(resa.data)
            }else{
                pago_modal1.show();
                idservicio_pago=conceptosa[i].idservicio;
                descripcion=conceptosa[i].Concepto;
            }
        }else {
            alert("Necesita pagar primero los servicios de nube para poder contratar estos servicios");
        }
    }
    async function pago_anualidad(){
        alert(idstripe);
            const data1 = new FormData()
            data1.append('month', MM);
            data1.append('year', AA);
            data1.append('cvc', cvc);
            data1.append('idstripe', idstripe);
            let resa = await fetch('php/alta-tarjeta.php', {
                method : "POST",
                body: data1
            })		
			resa = await resa.json()
			console.log(resa);
            if(resa){
            const data2 = new FormData()
            data2.append('idstripe', idstripe);
            data2.append('idtarjeta', resa);
            let resa1 = await fetch('php/guardar-tarjetas.php', {
                method : "POST",
                body: data2
            })	
            const data3 = new FormData()
            data3.append('idstripe', idstripe);
            let resa2 = await fetch('php/suscripcion-anual.php', {
                method : "POST",
                body: data3
            })		
            alert("Cobro realizado");
            pago_modal_anualidad.hide();
            }
    }
    async function contratar(){
        
        if(res3.data != ""){
            const data3 = new FormData()
            data3.append('idstripe', idstripe);
            let resa2 = await fetch('php/suscripcion-anual.php', {
                method : "POST",
                body: data3
            })		
            alert("Cobro realizado");
            const url12 = 'php/get-cliente.php?id=' + idcliente;
            let res12 = await fetch(url12)
            res12 = await res12.json()
            info = res12.data;
            console.log(info)
            idstripe=info.idstripe;
        }else{
            pago_modal_anualidad.show();
        }
    }
    async function pagar(i){
        console.log(res3.data)
        cantidad=conceptosa[i].Precio_mensual;
        cantidad = cantidad.replace(".","");
        if(res3.data != ""){
            idservicio_pago=conceptosa[i].idservicio;
            descripcion=conceptosa[i].Concepto;
            const data3 = new FormData()
            data3.append('idtarjeta', predeterminada);
            data3.append('idstripe', idstripe);
            data3.append('cantidad', cantidad);
            data3.append('descripcion', descripcion);
            data3.append('idservicio', idservicio_pago);
            data3.append('idcliente', idcliente);
            let res5 = await fetch('php/pago_servicio.php', {
                method : "POST",
                body: data3
            })	
            alert("Cobro realizado");
            const url1 = 'php/get-conceptos.php?id=' + idcliente;
            let resa = await fetch(url1)
            resa = await resa.json()
            conceptosa = resa.data;
            console.log(resa.data)
        }else{
            pago_modal1.show();
            idservicio_pago=conceptosa[i].idservicio;
            descripcion=conceptosa[i].Concepto;
        }
    }
    async function alta_serie_modal(){
        if(info.Tipo == "1"){
            modal_alta_serie.show();
        }else { if(info.Tipo == "2" && info.Series_Activas < 1){
                modal_alta_serie.show();
            }else { 
                if(info.Licencias_Pagadas > info.Series_Activas){
                    modal_alta_serie.show();
                }else{
                    alert("Llego el limite de licencias, para dar de alta otra tiene que comprarla")
                }
            }
        }
    }
    async function guardar_tarjeta(){
        alert(idstripe);
            const data1 = new FormData()
            data1.append('month', MM);
            data1.append('year', AA);
            data1.append('cvc', cvc);
            data1.append('idstripe', idstripe);
            let resa = await fetch('php/alta-tarjeta.php', {
                method : "POST",
                body: data1
            })		
			resa = await resa.json()
			console.log(resa);
            if(resa){
            const data2 = new FormData()
            data2.append('idstripe', idstripe);
            data2.append('idtarjeta', resa);
            let resa1 = await fetch('php/guardar-tarjetas.php', {
                method : "POST",
                body: data2
            })	
            pago_modal1.hide();
            const data3 = new FormData()
            data3.append('idtarjeta', resa);
            data3.append('idstripe', idstripe);
            data3.append('cantidad', cantidad);
            data3.append('descripcion', descripcion);
            data3.append('idservicio', idservicio_pago);
            data3.append('idcliente', idcliente);
            let res5 = await fetch('php/pago_servicio.php', {
                method : "POST",
                body: data3
            })	
            alert("Cobro realizado");
        }
    }
    async function editar_contacto(i){
        nombre_contacto_editar=contactos[i].contacto; 
        telefono_fijo_editar=contactos[i].telefono;
        celular_contacto_editar=contactos[i].celular;
        puesto_contacto_editar=contactos[i].puesto;
        correo_contacto_editar=contactos[i].correo;
        idcontacto = contactos[i].idcontacto;
        modal_modificar_contacto.show();
    }
    async function eliminar_contacto(i){
        idcontacto = contactos[i].idcontacto;
        if(contactos[i].tipo == 1){
            alert("No puede eliminar el contacto Representante de la empresa")
        } else {
            let r2 = window.confirm("¿Desea eliminar el contacto " + contactos[i].contacto + "?");
            if (r2 == true) {
                try {
                const data = new FormData()
                data.append('id', idcontacto);
                let res = await fetch('php/delete-contacto.php', {
                    method : "POST",
                    body: data
                })
                console.log(res)
                alert("Eliminado con exito");
                const url6 = 'php/get-contactos.php?id=' + idcliente;
                let res6 = await fetch(url6)
                res6 = await res6.json()
                contactos = res6.data;
                console.log(contactos)
            } catch(e) {
                const { responses } = e;
                const { request, ...errorObject } = responses; // take everything but 'request'
                console.log(errorObject);
                }
            }
        }
      }
    async function modificar_contacto(){
        try {
            const data = new FormData()
            data.append('contacto', nombre_contacto_editar);
            data.append('telefono', telefono_fijo_editar);
            data.append('celular', celular_contacto_editar);
            data.append('correo', correo_contacto_editar);
            data.append('puesto', puesto_contacto_editar);
            data.append('id', idcontacto);
            let res = await fetch('php/modificar-contacto.php', {
                method : "POST",
                body: data
            })
            console.log(res)
		alert("Modificado con exito");
        const url6 = 'php/get-contactos.php?id=' + idcliente;
        let res6 = await fetch(url6)
        res6 = await res6.json()
        contactos = res6.data;
        console.log(contactos)
        modal_modificar_contacto.hide();
	} catch(e) {
		const { responses } = e;
		const { request, ...errorObject } = responses; // take everything but 'request'
		console.log(errorObject);
		}
    }
    async function alta_contacto(){
        try {
            const data = new FormData()
            data.append('contacto', nombre_contacto);
            data.append('telefono', telefono_fijo);
            data.append('celular', celular_contacto);
            data.append('correo', correo_contacto);
            data.append('puesto', puesto_contacto);
            data.append('id', idcliente);
            let res = await fetch('php/alta-contacto.php', {
                method : "POST",
                body: data
            })
            console.log(res)
		    alert("Contacto creado con exito");
            const url6 = 'php/get-contactos.php?id=' + idcliente;
            let res6 = await fetch(url6)
            res6 = await res6.json()
            contactos = res6.data;
            console.log(contactos)
            modal_alta_contacto.hide();
	} catch(e) {
		const { responses } = e;
		const { request, ...errorObject } = responses; // take everything but 'request'
		console.log(errorObject);
		}
    }
    async function mostrar(){
    idcliente = $idcliente_serie;
    const url = 'php/get-cliente.php?id=' + idcliente;
    let res = await fetch(url)
    res = await res.json()
    series = res.data;
    SQL_Host = series.SQL_Host;
    SQL_Database = series.SQL_Database;
    SQL_Usuario = series.SQL_Usuario;
    SQL_Password = series.SQL_Pass;
    SQL_Puerto = series.SQL_Port;
    FTP_Host = series.FTP_Host;
    FTP_Directorio = series.FTP_Directorio;
    FTP_Usuario = series.FTP_Usuario;
    FTP_Password = series.FTP_Pass;
    FTP_Puerto = series.FTP_Port;
    correo_sesion = series.correo_sesion;
    password = series.password_cliente;
    console.log(series)
    modal.show();
    }

    async function editar(i){
    idserie = data[i].idlicencia;
    serie_editar = data[i].Serie;
    referencia_editar =data[i].Referencia;
    host_editar = data[i].Host_local;
    port_editar = data[i].Port;
    user_editar = data[i].User;
    passw_editar = data[i].Pass;
    sistem_editar = data[i].Sistema_Operativo;
    modal_editar_serie.show();
    }
    async function editar_serie(){
        try {
            const data = new FormData()
            data.append('sistema_operativo', sistem_editar);
            data.append('port', port_editar);
            data.append('user', user_editar);
            data.append('pass', passw_editar);
            data.append('host', host_editar);
            data.append('referencia', referencia_editar);
            data.append('id', idserie);
            let res = await fetch('php/modificar-serie.php', {
                method : "POST",
                body: data
            })
            console.log(res)
		alert("Modificado con exito");
        actualizar_series();
        modal_editar_serie.hide();
	} catch(e) {
		const { responses } = e;
		const { request, ...errorObject } = responses; // take everything but 'request'
		console.log(errorObject);
		}
    }
    async function alta_servicios(){
        try {
            const data = new FormData()
            data.append('concepto', concepto_alta);
            data.append('mensual', mensual_alta);
            data.append('fijo', fijo_alta);
            let res = await fetch('php/create-servicio.php', {
                method : "POST",
                body: data
            })
            console.log(res)
		    alert("creado con exito");        
            const url1 = 'php/get-conceptos.php?id=' + idcliente;
            let resa = await fetch(url1)
            resa = await resa.json()
            conceptosa = resa.data;
            console.log(resa.data)
            modal_alta_servicio.hide();
	} catch(e) {
		const { responses } = e;
		const { request, ...errorObject } = responses; // take everything but 'request'
		console.log(errorObject);
		}
    }
    async function actualizar_series(){
    const url = 'php/get-series.php?id=' + idcliente;
    let res = await fetch(url)
    res = await res.json()
    data = res.data;
    console.log(data)

    
    }
    async function conceptos(){
        modal_conceptos.show();
    }
    async function eliminar_servicio(i){
        idservicio = conceptosa[i].idservicio;
        let r2 = window.confirm("¿Desea eliminar el servicio " + conceptosa[i].Concepto + "?");
        if (r2 == true) {
            try {
            const data = new FormData()
            data.append('id', idservicio);
            let res = await fetch('php/delete-servicio.php', {
                method : "POST",
                body: data
            })
            console.log(res)
            alert("Eliminado con exito");
            const url1 = 'php/get-conceptos.php?id=' + idcliente;
            let resa = await fetch(url1)
            resa = await resa.json()
            conceptosa = resa.data;
            console.log(resa.data)
	} catch(e) {
		const { responses } = e;
		const { request, ...errorObject } = responses; // take everything but 'request'
		console.log(errorObject);
		}
        }
      }
    async function eliminar(i){
        idserie = data[i].idlicencia;
        let r2 = window.confirm("¿Desea eliminar la serie " + data[i].Serie + "de" + data[i].Referencia + "?");
        if (r2 == true) {
            try {
            const data = new FormData()
            data.append('id', idserie);
            let res = await fetch('php/delete-series.php', {
                method : "POST",
                body: data
            })
            console.log(res)
            actualizar_series();
	} catch(e) {
		const { responses } = e;
		const { request, ...errorObject } = responses; // take everything but 'request'
		console.log(errorObject);
		}
        }
      }
    function show_pago(){
		ver = true;
		ver1 = false;
        activar="pestaña";
        activar1="pestaña1";
	}
    function show_pago1(){
		ver = false;
		ver1 = true;
        activar="pestaña1";
        activar1="pestaña";
	}
    function showa(){
		show_a = true;
		show_a1 = false;
		show_a2 = false;
        show_a3 = false;
        actives="pestaña3";
        actives1="pestaña2";
        actives2="pestaña2";
        actives3="pestaña2";
	}
    function showa1(){
		show_a = false;
		show_a1 = true;
		show_a2 = false;
        show_a3 = false;
        actives="pestaña2";
        actives1="pestaña3";
        actives2="pestaña2";
        actives3="pestaña2";
	}
    function showa2(){
		show_a = false;
		show_a1 = false;
		show_a2 = true;
        show_a3 = false;
        actives="pestaña2";
        actives1="pestaña2";
        actives2="pestaña3";
        actives3="pestaña2";
	}
    function showa3(){
		show_a = false;
		show_a1 = false;
		show_a2 = false;
        show_a3 = true;
        actives="pestaña2";
        actives1="pestaña2";
        actives2="pestaña2";
        actives3="pestaña3";
	}
    function showan(){
		show = true;
		show1 = false;
		show2 = false;
        activer="pestaña1";
        activer1="pestaña";
        activer2="pestaña";
	}
    function showan1(){
		show = false;
		show1 = true;
		show2 = false;
        activer="pestaña";
        activer1="pestaña1";
        activer2="pestaña";
	}
    
    function showan2(){
		show = false;
		show1 = false;
		show2 = true;
        activer="pestaña";
        activer1="pestaña";
        activer2="pestaña1";
	}
    async function alta_serie(){
        try {
            const data = new FormData()
            data.append('serie', serie);
            data.append('sistema_operativo', sistem);
            data.append('port', port);
            data.append('user', user);
            data.append('pass', passw);
            data.append('host', host);
            data.append('referencia', referencia);
            data.append('id', idcliente);
            if(sistem == "Android"){
                data.append('tipo', "1");
            } else if(sistem == "IOS"){
                data.append('tipo', "1");
            } else{
                data.append('tipo', "0");
            }
            let res = await fetch('php/alta-series.php', {
                method : "POST",
                body: data
            })
            console.log(res)
		alert("creado con exito");
        actualizar_series();
        modal_alta_serie.hide();
        serie="";
        host = "127.0.0.1";
        port="3319";
        user = "root";
        passw = "root";
        sistem = "Windows";
	} catch(e) {
		const { responses } = e;
		const { request, ...errorObject } = responses; // take everything but 'request'
		console.log(errorObject);
		}
    }
</script>
<Top/>
<seciton>
    <div class="informacion_general">
        <div class="contenedor">
            <div class="row1">
                <div class="etiqueta">
                    <h3>General information</h3>
                </div>
            </div>
            <div class="row1">
                <div class="parte1">
                    <div class="info">
                        <h4><b>Company:</b> {info.Empresa}</h4>
                        <h4><b>Activation ID:</b> {info.ID_ACTIVACION}</h4>
                        <h4><b>Alta:</b> {info.Alta}</h4>
                        <h4><b>Tipo:</b> {tipo}</h4>
                        <h4><b>Licenses:</b> {info.Licencias_Pagadas}</h4>
                        <h4><b>Series:</b> {info.Series_Activas}</h4>
                    </div>
                </div>
                <div class="parte2">
                    <div class="botones_info">
                        <div class="ajuste">
                            <button  on:click={() => modal_contactos.show()}>Contacts <img src="./img/contactos.svg" alt=""></button>
                            <button on:click={() => mostrar()}>Credentials <img src="./img/db.svg" alt=""></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</seciton>
<seciton>
    <div class="informacion_general">
        <div class="contenedor">
            <div class="row1">
                <div class="etiqueta">
                    <h3>Series</h3>
                </div>
                <div class="icon" on:click={() => alta_serie_modal()}>
                    <img src="./img/mas.svg" alt="">
                </div>
            </div>
        </div>
    </div>
</seciton>
<div class="tabla_clientes">
    <table>
        <thead>
            <th class="column_s">Serie</th>
            <th class="column_s1">Register</th>
            <th class="column_s2">Operating system</th>
            <th class="column_s3">Reference</th>
            <th class="column_s4">Host</th>
            <th class="column_s5"></th>
            <th class="column_s6"></th>
        </thead>
        <tbody>
            {#if data}
            {#each data as row, i}
            <tr>
                <td class="column_s">{row.Serie}</td>
                <td class="column_s1">{row.Alta}</td>
                <td class="column_s2">{row.Sistema_Operativo}</td>
                <td class="column_s3">{row.Referencia}</td>
                <td class="column_s4">{row.Host_local}</td>
                <td class="column_s5" on:click={() => editar(i)}><img src="./img/editar.svg" alt=""></td>
                <td class="column_s6" on:click={() => eliminar(i)}><img src="./img/menos.svg" alt=""></td>
            </tr>
            {/each}
            {/if}
        </tbody>
    </table>
</div>
<div class="tabla_clientes_movil">
    <div class="tabla_tecnicos_movil">
        {#each data as row, i}
        <div class="renglon">
            <h4><b>Serie: </b>{row.Serie}</h4>
            <h4><b>Register: </b>{row.Alta}</h4>
            <h4><b>Operating system: </b>{row.Sistema_Operativo}</h4>
            <h4><b>Reference: </b>{row.Referencia}</h4>
            <h4><b>Host: </b>{row.Host_local}</h4>
            <h3 on:click={() => editar(i)}><img src="./img/editar.svg" alt=""></h3>
            <h3 on:click={() => eliminar(i)}><img src="./img/menos.svg" alt=""></h3>
        </div>
        {/each}
    </div>
</div>

<Modal_alta bind:this={modal_alta_serie}>
    <form on:submit|preventDefault={alta_serie}>
        <h2 class="titulo-modal">New serie</h2>
        <h4 class="texto_modal">Serial number</h4>
        <input type="text" class="input_modal" bind:value={serie} required placeholder="número alfanumerico">
        <h4 class="texto_modal">Reference or assigned</h4>
        <input type="text" class="input_modal"  bind:value={referencia} required>
        <h4 class="texto_modal">Operating system</h4>
        <h4 class="modal_h4">
            <input type="radio" bind:group={sistem} value={"Windows"}> Windows
        </h4>
        <h4 class="modal_h4">
            <input type="radio" bind:group={sistem} value={"linux"}> Linux
        </h4>
        <h4 class="modal_h4">
            <input type="radio" bind:group={sistem} value={"Mac OS"}> Mac OS
        </h4>
        <h4 class="modal_h4">
            <input type="radio" bind:group={sistem} value={"Android"}> Android
        </h4>
        <h4 class="modal_h4">
            <input type="radio" bind:group={sistem} value={"IOS"}> IOS
        </h4>
        <div class="row1">
            <div class="parte1_serie">
                <h4 class="texto_serie">Connection Host:</h4>
                <input type="text" class="input_serie"  bind:value={host} required>
            </div>
            <div class="parte2_serie">
                <h4 class="texto_serie">Port:</h4>
                <input type="text" class="input_serie"  bind:value={port} required>
            </div>
        </div>
        <h4 class="texto_modal">User:</h4>
        <input type="text" class="input_modal"  bind:value={user} required>
        <h4 class="texto_modal">Password:</h4>
        <input type="text" class="input_modal"  bind:value={passw} required>
        <button class="modal_button" type="submit">Generate</button>
    </form>
</Modal_alta>
<Modal_alta bind:this={modal_editar_serie}>
    <form on:submit|preventDefault={editar_serie}>
        <h2 class="titulo-modal">Serial information</h2>
        <h4 class="texto_modal">Serial number</h4>
        <input type="text" class="input_modal" bind:value={serie_editar} disabled placeholder="número alfanumerico">
        <h4 class="texto_modal">Reference or assigned</h4>
        <input type="text" class="input_modal"  bind:value={referencia_editar} required>
        <h4 class="texto_modal">Operating system</h4>
        <h4 class="modal_h4">
            <input type="radio" bind:group={sistem_editar} value={"Windows"}> Windows
        </h4>
        <h4 class="modal_h4">
            <input type="radio" bind:group={sistem_editar} value={"linux"}> Linux
        </h4>
        <h4 class="modal_h4">
            <input type="radio" bind:group={sistem_editar} value={"Mac OS"}> Mac OS
        </h4>
        <h4 class="modal_h4">
            <input type="radio" bind:group={sistem_editar} value={"Android"}> Android
        </h4>
        <h4 class="modal_h4">
            <input type="radio" bind:group={sistem_editar} value={"IOS"}> IOS
        </h4>
        <div class="row1">
            <div class="parte1_serie">
                <h4 class="texto_serie">Connection Host:</h4>
                <input type="text" class="input_serie"  bind:value={host_editar} required>
            </div>
            <div class="parte2_serie">
                <h4 class="texto_serie">Port:</h4>
                <input type="text" class="input_serie"  bind:value={port_editar} required>
            </div>
        </div>
        <h4 class="texto_modal">User:</h4>
        <input type="text" class="input_modal"  bind:value={user_editar} required>
        <h4 class="texto_modal">Password:</h4>
        <input type="text" class="input_modal"  bind:value={passw_editar} required>
        <button class="modal_button" type="submit">Modificar Serie</button>
    </form>
</Modal_alta>
<Modal bind:this={modal_conceptos}>
    <div class="cabecera_modal">
        <div class="row1">
            <div class="{actives}" on:click={showa}>
                <h4>Base modules</h4>
            </div>
            <div class="{actives1}" on:click={showa1}>
                <h4>Distributor modules</h4>
            </div>
            <div class="{actives2}" on:click={showa2}>
                <h4>Websites</h4>
            </div>
            <div class="{actives3}" on:click={showa3}>
                <h4>Apps</h4>
            </div>
        </div>
    </div>
    <div>
        {#if show_a}
        <div class="tabla_servicios">
            <table>
                <thead>
                    <th class="column">Concept</th>
                    <th class="column1">Price</th>
                </thead>
                <tbody>
                    {#each conceptosa as conceptos, i}
                        {#if conceptos.Tipo == "Modulo base"}
                            <tr>
                                <td class="column">{conceptos.Concepto}</td>
                                <td class="column1">$ {conceptos.Precio_mensual}</td>
                                {#if conceptos.activo}
                                <img  on:click={() => desactivar(i)} class=imagen_tabla_modal src="./img/menos.svg" alt="">
                                {:else}
                                <button on:click={() => pagar(i)}>Pagar</button>
                                {/if}
                            </tr>
                        {/if}
                    {/each}
                </tbody>
            </table>
        </div>
        {/if}
        {#if show_a1}  
        <div class="tabla_servicios">
            <table>
                <thead>
                    <th class="column">Concept</th>
                    <th class="column1">Price</th> </thead>
                <tbody>
                    {#each conceptosa as conceptos, i}
                        {#if conceptos.Tipo == "Modulo distribuidor"}
                            <tr>
                                <td class="column">{conceptos.Concepto}</td>
                                <td class="column1">$ {conceptos.Precio_mensual}</td>
                                {#if conceptos.activo}
                                    <img  on:click={() => desactivar(i)} class=imagen_tabla_modal src="./img/menos.svg" alt="">
                                {:else}
                                    <button on:click={() => pagar(i)}>Pagar</button>
                                {/if}
                            </tr>
                        {/if}
                    {/each}
                </tbody>
            </table>
        </div>
        {/if}
        {#if show_a2}
        <div class="tabla_servicios">
            <table>
                <thead>
                    <th class="column">Concept</th>
                    <th class="column1">Price</th>
                </thead>
                <tbody>
                    {#each conceptosa as conceptos, i}
                        {#if conceptos.Tipo == "WEB"}
                            <tr>
                                <td class="column">{conceptos.Concepto}</td>
                                <td class="column1">$ {conceptos.Precio_mensual}</td>
                                    {#if conceptos.activo}
                                    <img  on:click={() => desactivar(i)} class=imagen_tabla_modal src="./img/menos.svg" alt="">
                                    {:else}
                                    <button on:click={() => pagar_online1(i)}>Pagar</button>
                                    {/if}
                            </tr>
                        {/if}
                    {/each}
                </tbody>
            </table>
        </div>
        {/if}
        {#if show_a3}
        <div class="tabla_servicios">
            <table>
                <thead>
                    <th class="column">Concept</th>
                    <th class="column1">Price</th>
                </thead>
                <tbody>
                    {#each conceptosa as conceptos, i}
                        {#if conceptos.Tipo == "App"}
                            <tr>
                                <td class="column">{conceptos.Concepto}</td>
                                <td class="column1">$ {conceptos.Precio_mensual}</td>
                                {#if conceptos.activo}
                                    <img  on:click={() => desactivar(i)} class=imagen_tabla_modal src="./img/menos.svg" alt="">
                                    {:else}
                                    <button on:click={() => pagar_online(i)}>pay</button>
                                {/if}
                            </tr>
                        {/if}
                    {/each}
                </tbody>
            </table>
        </div>
        {/if}
    </div>
   
</Modal>

<Modal_alta bind:this={modal_alta_servicio}>
    <form on:submit|preventDefault={alta_servicios}>
        <h2 class="titulo-modal">New module</h2>
        <h4 class="texto_modal">Concept</h4>
        <input type="text" class="input_modal" bind:value={concepto_alta} required>
        <h4 class="texto_modal">Monthly price</h4>
        <input type="text" class="input_modal" bind:value={mensual_alta} required>
        <h4 class="texto_modal">Fixed price</h4>
        <input type="text" class="input_modal" bind:value={fijo_alta}>
        <button class="modal_button" type="submit">save</button>
    </form>
</Modal_alta>

<Modal2 bind:this={modal}>
    <div class="cabecera_modal">
        <div class="row1">
            <div class="{activer}" on:click={showan}>
                <h4>DB Connection</h4>
            </div>
            <div class="{activer1}" on:click={showan1}>
                <h4>FTP Credentials</h4>
            </div>
        </div>
    </div>
    {#if show}
    <div class="ajuste_modal_info">
            <h4><b>SQL Host:</b>{SQL_Host}</h4>
            <h4><b>SQL Database:</b>{SQL_Database}</h4>
            <h4><b>SQL User:</b>{SQL_Usuario}</h4>
            <h4><b>SQL Password:</b>{SQL_Password}</h4>
            <h4><b>SQL Port:</b>{SQL_Puerto}</h4>
            <h4><b>Session email:</b> {correo_sesion}</h4>
            <h4><b>Password:</b> {password}</h4>
    </div>
    {/if}
    {#if show1}
    <div class="ajuste_modal_info">
        <h4><b>FTP Host:</b>{FTP_Host}</h4> 
        <h4><b>FTP Directorio:</b>{FTP_Directorio}</h4>
        <h4><b>FTP User:</b>{FTP_Usuario}</h4>
        <h4><b>FTP Password:</b>{FTP_Password}</h4>
        <h4><b>FTP Port:</b>{FTP_Puerto}</h4>
    </div>
    {/if}
</Modal2>
<Modal bind:this={modal_contactos}>
    <h2 class="titulo-modal">Contacts</h2>
    <div class="tabla_tecnicos">
        <table>
            <thead>
                <th class="column_modal">Name</th>
                <th class="column_modal1">Phone</th>
                <th class="column_modal2">Cell phone</th>
                <th class="column_modal3">Email</th>
                <th class="column_modal4">Position</th>
                <th class="column_modal5">Type</th>
                <th class="column_modal5"></th>
                <th class="column_modal6"  on:click={() => modal_alta_contacto.show()}><img src="./img/mas.svg" alt=""></th>
            </thead>
            <tbody>
                {#if contactos}
                    {#each contactos as Contactos, i}
                            <tr>
                                <td class="column_modal">{Contactos.contacto}</td>
                                <td class="column_modal1">{Contactos.telefono}</td>
                                <td class="column_modal2">{Contactos.celular}</td>
                                <td class="column_modal3">{Contactos.correo}</td>
                                <td class="column_modal4">{Contactos.puesto}</td>
                                <td class="column_modal5">{Contactos.Tipo}</td>       
                                <td class="column_modal5" on:click={() => editar_contacto(i)}><img src="./img/editar.svg" alt=""></td>
                                <td class="column_modal6" on:click={() => eliminar_contacto(i)}><img src="./img/menos.svg" alt=""></td>
                            </tr>
                    {/each}
                {/if}
            </tbody>
        </table>
    </div>
</Modal>
<Modal_alta bind:this={modal_alta_contacto}>
    <form on:submit|preventDefault={alta_contacto}>
        <h2 class="titulo-modal">New Contact</h2>
        <h4 class="texto_modal">Name</h4>
        <input type="text" class="input_modal" bind:value={nombre_contacto} required>
        <h4 class="texto_modal">Phone</h4>
        <input type="text" class="input_modal" bind:value={telefono_fijo} required>
        <h4 class="texto_modal">Cell phone</h4>
        <input type="text" class="input_modal" bind:value={celular_contacto}>
        <h4 class="texto_modal">Email</h4>
        <input type="text" class="input_modal" bind:value={correo_contacto}>
        <h4 class="texto_modal">Position</h4>
        <input type="text" class="input_modal" bind:value={puesto_contacto}>
        <button class="modal_button" type="submit">Save</button>
    </form>
</Modal_alta>

<Modal_alta bind:this={modal_modificar_contacto}>
    <form on:submit|preventDefault={modificar_contacto}>
        <h2 class="titulo-modal">Modify contact information</h2>
        <h4 class="texto_modal">Name</h4>
        <input type="text" class="input_modal" bind:value={nombre_contacto_editar} required>
        <h4 class="texto_modal">Phone</h4>
        <input type="text" class="input_modal" bind:value={telefono_fijo_editar} required>
        <h4 class="texto_modal">Cell phone</h4>
        <input type="text" class="input_modal" bind:value={celular_contacto_editar}>
        <h4 class="texto_modal">Email</h4>
        <input type="text" class="input_modal" bind:value={correo_contacto_editar}>
        <h4 class="texto_modal">Position</h4>
        <input type="text" class="input_modal" bind:value={puesto_contacto_editar}>
        <button class="modal_button" type="submit">Modify</button>
    </form>
</Modal_alta>

<Modal_alta bind:this={pago_modal1}>
    <h2 class="titulo-modal">Payment method</h2>
    <form on:submit|preventDefault={guardar_tarjeta}>
        <div class="container_tarjeta"> 
            <h4>Card number</h4>
            <input type="number" bind:value={tarjeta_number} class="input_modal">
            <h4>Validity</h4>
            <input type="text" class="input_modal_2" bind:value={MM} placeholder="MM">/<input type="text" class="input_modal_2" bind:value={AA} placeholder="AA">
            <h4>CVV</h4>
            <input type="number"  bind:value={cvc} class="input_modal">
            <input type="submit" class="modal_button" value="Pay">
        </div>
    </form>
</Modal_alta>
<Modal_alta bind:this={pago_modal_anualidad}>
    <h2 class="titulo-modal">Payment method</h2>
    <form on:submit|preventDefault={pago_anualidad}>
        <div class="container_tarjeta">
            <h4>Card number</h4>
            <input type="number" bind:value={tarjeta_number} class="input_modal">
            <h4>Validity</h4>
            <input type="text" class="input_modal_2" bind:value={MM} placeholder="MM">/<input type="text" class="input_modal_2" bind:value={AA} placeholder="AA">
            <h4>CVV</h4>
            <input type="number"  bind:value={cvc} class="input_modal">
            <input type="submit" class="modal_button" value="Pay">
        </div>
    </form>
</Modal_alta>
<Modal_alta bind:this={pago_modal3}>
    <h2 class="titulo-modal">Payment method</h2>
    <form on:submit|preventDefault={pago_mensualidad}>
        <div class="container_tarjeta"> 
            <h4>Card number</h4>
            <input type="number" bind:value={tarjeta_number} class="input_modal">
            <h4>Validity</h4>
            <input type="text" class="input_modal_2" bind:value={MM} placeholder="MM">/<input type="text" class="input_modal_2" bind:value={AA} placeholder="AA">
            <h4>CVV</h4>
            <input type="number"  bind:value={cvc} class="input_modal">
            <input type="submit" class="modal_button" value="Pay">
        </div>
    </form>
</Modal_alta>
<Modal_alta bind:this={pago_modal}>
    <div class="cabecera_modal">
        <div class="row1">
            <div class="{activar}" on:click={show_pago}>
                <h4>Information</h4>
            </div>
            <div class="{activar1}" on:click={show_pago1}>
                <h4>Payment method</h4>
            </div>
        </div>
    </div>
    {#if ver}
        <div class="row1"> 
            <div class="parte3_modal">
                <h2>payment for online services</h2>
            </div>
            <div class="parte4_modal">
                <h2>$ {precio_suscripcion}</h2>
            </div>
        </div>
        <div class="row1"> 
            <div class="parte3_modal">
                <h2>date next payment</h2>
            </div>
            <div class="parte4_modal">
                <h2>{fecha_proximo}</h2>
            </div>
        </div>
        <hr>        
      
        <div class="row1"> 
            <div class="parte3_modal">
                <h4><b>Extras</b></h4>          
            </div>
            <div class="parte4_modal">
                <div on:click={() => licencia_tecnico()} class="mas"><img src="./img/mas.svg" alt=""></div>
            </div>
        </div>
        <hr>
        {#each cargos_extra as cargos_extra, i}
            <div class="row1"> 
                <div class="parte5_modal">
                    <h4>{cargos_extra.Concepto}</h4>            
                </div>
                <div class="parte6_modal">
                    <h4>$ {cargos_extra.Pago}</h4>
                </div>
            </div>
        {/each}
        {#if cargos_extra}
            <hr>
        {/if}
        {#if idmensualidad}
        <div class="row1"> 
            <div class="parte3_modal">
                <h4>Monthly Payment</h4>
                <h4><b>Next payment</b></h4>              
            </div>
            <div class="parte4_modal">
                <h4>$ {precio_mensualidad}</h4>
                <h4>{fecha_proxima_mensualidad}</h4>
            </div>
        </div>
       {/if}
    {/if}
    {#if ver1}
        <div class="container_tarjeta"> 
            <div class="row1">
                <div class="modal_frac1_cabecera">
                    <h4>Card number</h4>
                </div>
                <div class="modal_frac2_cabecera">
                    <h4>Type</h4>
                </div>
                <div class="modal_frac3_cabecera">
                    <img on:click={() => agregar_tarjeta()} src="./img/mas.svg" alt="">
                </div>
            </div>
            <hr>
            <form on:submit|preventDefault={modificar_preferente}>
            {#each tarjetas as Tarjetas, i}
            <div class="row1">
                <div class="modal_frac1">
                        <input bind:group={predeterminada} type="radio" name="amount" value={Tarjetas.id} />
                </div>
                <div class="modal_frac2">
                    <h4>**** **** **** {Tarjetas.last4}</h4>
                </div>
                <div class="modal_frac3">
                    {#if Tarjetas.brand == "Visa"}
                        <img src="./img/visa.svg" alt="">
                    {:else}
                        <img src="./img/mastercard.svg" alt="">
                    {/if}
                </div>
                <div class="modal_frac4">
                    <img on:click={() => eliminar_tarjeta(i)} src="./img/menos.svg" alt="">
                </div>
            </div>
            {/each}
            <button class="modal_button"  type="submit">Save changes</button>
            </form>
        </div>
    {/if}
</Modal_alta>

<Modal_alta bind:this={modal_agregar_tarjeta}>
    <h2 class="titulo-modal">New Card</h2>
    <form on:submit|preventDefault={agregar_tarjeta_nueva}>
        <div class="container_tarjeta"> 
            <h4>Card number</h4>
            <input type="number" bind:value={tarjeta_number} class="input_modal">
            <h4>Validityo</h4>
            <input type="text" class="input_modal_2" bind:value={MM} placeholder="MM">/<input type="text" class="input_modal_2" bind:value={AA} placeholder="AA">
            <h4>CVV</h4>
            <input type="number"  bind:value={cvc} class="input_modal">
            <input type="submit" class="modal_button" value="Add card">
        </div>
    </form>
</Modal_alta>